export default class AverageSessionsModel {
  constructor(data) {
    this.userId = data.userId;
    this.sessions = data.sessions;
  }
}
